'use client'

// Add global type for window.gtag
declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

import { AnimatePresence, motion } from 'framer-motion'
import { useState, useEffect } from 'react'

export default function ConsentBanner({ lang }: { lang?: string }) {
  const [visible, setVisible] = useState(false)
  const isArabic = lang == 'ar'

  useEffect(() => {
    // Show only if not already decided
    const saved = localStorage.getItem('cookie-consent')
    if (!saved) setVisible(true)
    // if (saved === 'denied') setVisible(true)
  }, [])

  const handleConsent = (status: 'granted' | 'denied') => {
    localStorage.setItem('cookie-consent', status)
    setVisible(false)
  }


  //   if (!visible) return null

  return (
    <AnimatePresence>
      {visible && (
        <>
          {/* Black overlay (only visible on mobile) */}
          <motion.div
            className="fixed inset-0 bg-black/50 z-[49] md:hidden"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
          />

          {/* Banner */}
          <motion.div
            className="fixed bottom-0 md:hidden left-0 right-0 z-50 bg-white px-4 py-10 text-[14px] flex flex-col md:flex-row items-start justify-between gap-8"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            <p className="text-gray-800 text-left md:text-left">
              We use cookies to enhance your browsing experience and analyze website traffic.{' '}
            </p>
            <div className="w-full flex justify-end">
              <div className="flex text-right gap-2">
                <button
                  onClick={() => handleConsent('granted')}
                  className="px-10 py-4 rounded-md bg-[#ff5938] text-white "
                >
                  Accept
                </button>
                <button
                  onClick={() => handleConsent('denied')}
                  className="px-10 py-4 rounded-md bg-white border-[1px] border-[#ff5938] text-[#ff5938] "
                >
                  Reject
                </button>
              </div>
            </div>
          </motion.div>
          {/* Desktop Banner */}
          <motion.div
            className="fixed bottom-0 w-full z-50 bg-white px-4 pt-7 pb-6 text-[16px] hidden md:flex flex-row xl:h-40 items-start justify-between gap-5"
            initial={{ y: '100%' }}
            animate={{ y: 0 }}
            exit={{ y: '100%' }}
            transition={{ type: 'spring', stiffness: 300, damping: 30 }}
          >
            {isArabic ? (
              <p className="text-gray-800 text-right lg:hidden md:text-left">
                نحن نستخدم ملفات تعريف الارتباط لتحسين تجربتك في التصفح وتحليل حركة المرور على
                الموقع.
              </p>
            ) : (
              <p className="text-gray-800 text-left lg:hidden md:text-left">
                We use cookies to enhance your browsing experience and analyze website traffic.
              </p>
            )}
            {isArabic ? (
              <p className="text-gray-800 text-right hidden lg:block md:text-left">
                نستخدم ملفات تعريف الارتباط لتحسين تجربتك في التصفح، وتخصيص المحتوى، وتحليل حركة
                المرور. بمتابعتك، فإنك توافق على استخدامنا لملفات تعريف الارتباط. قد تقوم Google
                بمعالجة البيانات للإعلانات والتحليلات. يمكنك إدارة تفضيلاتك في أي وقت من خلال
                إعدادات الخصوصية والموافقة.{' '}
              </p>
            ) : (
              <p className="text-gray-800 text-left hidden lg:block md:text-left">
                We use cookies to improve your browsing, personalize content, and analyze traffic.
                By continuing, you agree to our use of cookies. Google may process data for ads and
                analytics. Manage preferences anytime in our privacy and consent settings.
              </p>
            )}
            <div className="flex h-full items-end justify-end">
              <div className="flex text-[14px] text-right gap-2">
                <button
                  onClick={() => handleConsent('granted')}
                  className="px-6 py-2 rounded-md bg-[#ff5938] text-white "
                >
                  Accept
                </button>
                <button
                  onClick={() => handleConsent('denied')}
                  className="px-6 py-2 rounded-md bg-white border-[1px] border-[#ff5938] text-[#ff5938] "
                >
                  Reject
                </button>
              </div>
            </div>
          </motion.div>
        </>
      )}
    </AnimatePresence>
  )
}
